import { createClient } from '@supabase/supabase-js';
/**
 * Creates a new Supabase browser client typed to the generated Database schema.
 *
 * Uses `createClient` from `@supabase/supabase-js` which stores auth tokens in
 * localStorage. This avoids Safari ITP (Intelligent Tracking Prevention) issues
 * that occur with cookie-based storage (`@supabase/ssr`) during OAuth redirects.
 */
export function createSupabaseClient(config) {
    return createClient(config.url, config.anonKey, {
        auth: {
            detectSessionInUrl: true,
            flowType: 'pkce',
            persistSession: true,
        },
    });
}
let _instance = null;
/**
 * Returns the shared browser client singleton.
 * Config is required on the first call; subsequent calls reuse the instance.
 */
export function getBrowserClient(config) {
    if (!_instance) {
        if (!config) {
            throw new Error('getBrowserClient: config is required on first call. Provide { url, anonKey }.');
        }
        _instance = createSupabaseClient(config);
    }
    return _instance;
}
/**
 * Resets the singleton. Useful in tests to start fresh between cases.
 */
export function resetClient() {
    _instance = null;
}
//# sourceMappingURL=client.js.map